import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Stack } from "@mui/material";
import "./components.css";
import { useTranslation } from "react-i18next";
import DeclineConfirmationPopup from "./DeclineConfirmationPopup";

function ConsentButtons(props) {
  const { t } = useTranslation();
  const [value, setValue] = useState();
  const [declineConsentData, setDeclineConsentData] = useState("");
  const [isDeclinedConsent, setIsDeclinedConsent] = useState(false);
  const theme = createTheme({
    palette: {
      neutral: {
        main: "#00634A",
        contrastText: "#fff",
      },
    },
  });

  useEffect(() => {
    setValue(props?.value);
  }, [props?.value]);

  const onClick = (e) => {
    setValue(e.target.value);
    props.onClick(e);
  };
  const handleDeclineConsent = (action) => {
   if(action === "Confirm") {
      onClick(declineConsentData);
      setDeclineConsentData("");
      setIsDeclinedConsent(false);
    } else if(action === "Cancel") {
      setIsDeclinedConsent(false);
      setDeclineConsentData("");
    }
  };
  const triggerDeclineConsentPopup = (data) => {
    if(props?.value !== "I Decline") {
      setIsDeclinedConsent(true);
      setDeclineConsentData(data);
    }
  }
  return (
    <div>
      <ThemeProvider theme={theme}>
        <Stack
          style={{
            pointerEvents: props.disabled ? "none" : "auto",
            marginLeft: "auto", // Align to the right
          }}
          spacing={2}
          direction="row"
        >
          <Button
            value="I Agree"
            name={props.name}
            color="neutral"
            onTransitionEnd={(e) => props.onLoad(e)}
            onClick={(e) => onClick(e)}
            className={
              ["I Agree", "i Agree"].includes(value)
                ? "activeYesButton"
                : "inActiveNoButton"
            }
            data-testId={props.name + "True"}
          >
            {t("I Agree")}
          </Button>
          <Button
            value="I Decline"
            name={props.name}
            color="neutral"
            onTransitionEnd={(e) => props.onLoad(e)}
            // onClick={(e) => onClick(e)}
            onClick={(e) => triggerDeclineConsentPopup(e)}
            className={
              ["I Decline", "i Decline"].includes(value)
                ? "activeYesButton"
                : "inActiveNoButton"
            }
            data-testId={props.name + "False"}
          >
            {t("I Decline")}
          </Button>
        </Stack>
      </ThemeProvider>
      {isDeclinedConsent && (
        <DeclineConfirmationPopup
          open={isDeclinedConsent}
          handleClose={(action) => handleDeclineConsent(action)}
          declineConsentButtonName={props?.name}
        />
      )}
    </div>
  );
}

export default ConsentButtons;
